import { render, staticRenderFns } from "./liveAreaN.vue?vue&type=template&id=453e978c&scoped=true"
import script from "./liveAreaN.vue?vue&type=script&lang=js"
export * from "./liveAreaN.vue?vue&type=script&lang=js"
import style0 from "./liveAreaN.vue?vue&type=style&index=0&id=453e978c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e978c",
  null
  
)

export default component.exports